<ng-container *ngIf="initiateResponseCard">
  <form
    [action]="initiateResponseCard.acsUrl"
    method="post"
    id="acs-form"
    class="cdk-visually-hidden"
    hidden
    target="output_frame"
  >
    <input name="MD" [value]="initiateResponseCard.acsMD" id="MD" hidden />
    <input
      name="PaReq"
      [value]="initiateResponseCard.acsPayload"
      id="PaReq"
      hidden
    />
    <input
      name="TermUrl"
      [value]="initiateResponseCard.acsTermUrl"
      id="TermUrl"
      hidden
    />
  </form>
</ng-container>
<form
  class="grid grid-cols-1 mt-4 md:mt-11"
  [formGroup]="cardForm"
  (keydown.enter)="formSubmit($event)"
  *ngIf="!formSubmitted"
>
  <div class="flex justify-center gap-6 mb-8">
    <img
      *ngFor="let cardType of supportedCardSchemas"
      class="card-types"
      [src]="cardType.imageName"
      [alt]="cardType.cardName"
    />
  </div>
  <h3 class="font-bold mb-2 text-center md:text-left">
    Please enter your cardholder details
  </h3>
  <mat-form-field
    class="w-full tile my-1 md:my-2"
    appearance="none"
    (click)="selectCardWhenFormIsDisabled()"
  >
    <mat-label><strong>Card Number</strong></mat-label>
    <div class="flex items-center">
      <input
        id="cardnumber"
        matInput
        formControlName="cardNumber"
        [errorStateMatcher]="matcher"
        (keyup)="styleDynamicCard($event)"
        (paste)="styleDynamicCard($event)"
        autocomplete="cc-number"
        maxlength="23"
      />
      <!-- Transparent overlay when input should be prevented -->
      <div
        *ngIf="activeCard"
        class="absolute inset-0 z-10 cursor-pointer"
        (click)="selectCardWhenFormIsDisabled()"
      ></div>
      <mat-icon
        class="cursor-pointer hover:scale-150 float-right"
        *ngIf="sessionData.savedCards.length > 0"
        (click)="selectCard()"
        matTooltip="Load saved cards"
        >credit_card</mat-icon
      >
    </div>
    <mat-error *ngIf="cardForm.invalid">
      {{
        cardNumberError === "minlength" || cardNumberError === "maxlength"
          ? "Invalid Card Number"
          : cardNumberError
      }}
    </mat-error>
    <!-- <svg id="ccicon" class="ccicon" viewBox="0 0 750 471" version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
            </svg> -->
  </mat-form-field>
  <div [ngClass]="getCssClasses()">
    <mat-form-field
      class="w-full tile my-1 md:my-2"
      appearance="none"
      (click)="selectCardWhenFormIsDisabled()"
    >
      <mat-label><strong>Expiry Month</strong></mat-label>
      <mat-select
        formControlName="cardExpiryMonth"
        [disabled]="cardForm.controls.cardExpiryMonth.disabled"
        #matSelectMonth
        (selectionChange)="expiryMonthSelected(cardExpiryMonthOpt)"
        [errorStateMatcher]="matcher"
      >
        <mat-option *ngFor="let x of expiryMonths" [value]="x.id">{{
          x.id
        }}</mat-option>
      </mat-select>
      <mat-error *ngIf="cardForm.invalid">
        {{ cardExpiryMonthError }}
      </mat-error>
    </mat-form-field>
    <mat-form-field
      class="w-full tile my-1 md:my-2"
      appearance="none"
      (click)="selectCardWhenFormIsDisabled()"
    >
      <mat-label><strong>Expiry Year</strong></mat-label>
      <mat-select
        formControlName="cardExpiryYear"
        [disabled]="cardForm.controls.cardExpiryYear.disabled"
        #matSelectYear
        (selectionChange)="expiryYearSelected(cardExpiryYearOpt)"
        [errorStateMatcher]="matcher"
      >
        <mat-option *ngFor="let year of expiryYears" [value]="year">{{
          year
        }}</mat-option>
      </mat-select>
      <mat-error *ngIf="cardForm.invalid">
        {{ cardExpiryYearError }}
      </mat-error>
    </mat-form-field>
    <mat-form-field
      class="w-full tile my-1 md:my-2"
      appearance="none"
      *ngIf="cvvRequired"
    >
      <mat-label><strong>CVV</strong></mat-label>
      <input
        class="masked-input"
        type="text"
        autocomplete="text"
        id="cc"
        name="cc"
        (keydown)="onlyNumbers($event, cardForm)"
        matInput
        formControlName="cardCVV"
        [errorStateMatcher]="matcher"
        maxlength="4"
        inputmode="numeric"
      />
      <mat-error *ngIf="cardForm.invalid">
        {{ cardCVVError }}
      </mat-error>
    </mat-form-field>
  </div>
  <mat-form-field
    class="w-full tile my-1 md:my-2"
    appearance="none"
    (click)="selectCardWhenFormIsDisabled()"
  >
    <mat-label><strong>Cardholder's Name</strong></mat-label>
    <input
      type="text"
      matInput
      formControlName="cardHolder"
      [errorStateMatcher]="matcher"
      placeholder="Joe Soap"
    />
    <div
    *ngIf="activeCard"
    class="absolute inset-0 z-10 cursor-pointer"
    (click)="selectCardWhenFormIsDisabled()"
    ></div>
    <mat-error *ngIf="cardForm.controls.cardHolder.invalid">
      {{ cardHolderError }}
    </mat-error>
  </mat-form-field>
  <mat-form-field
    class="w-1/2 tile my-1 md:my-2"
    *ngIf="budgetAllowed"
    appearance="none"
    (click)="selectCardWhenFormIsDisabled()"
  >
    <mat-label><strong>Payment Period</strong></mat-label>
    <mat-select
      formControlName="cardPaymentPeriod"
      [errorStateMatcher]="matcher"
      [disabled]="loading"
    >
      <mat-option
        *ngFor="let paymentPeriod of paymentPeriods"
        [value]="paymentPeriod.code"
        >{{ paymentPeriod.name }}</mat-option
      >
    </mat-select>
    <mat-error *ngIf="cardForm.invalid">
      {{ cardPaymentPeriodError }}
    </mat-error>
  </mat-form-field>
  <!-- Lifestyle Rewards Mobile Number -->
  <div *ngIf="lifestyleRewardsAvailable" class="my-4">
    <mat-form-field
      class="w-full tile my-1 md:my-2"
      appearance="none"
    >
      <mat-label><strong>Mobile Number (Optional)</strong></mat-label>
      <input
        type="tel"
        matInput
        formControlName="rewardsMobileNumber"
        [errorStateMatcher]="matcher"
        placeholder="0821234567"
        maxlength="10"
        inputmode="tel"
      />
      <mat-error *ngIf="cardForm.controls.rewardsMobileNumber.invalid">
        {{ rewardsMobileNumberError }}
      </mat-error>
    </mat-form-field>
    <p class="text-sm mt-1">
      <mat-icon class="align-middle text-base">card_giftcard</mat-icon>
      Provide your mobile number to earn Lifestyle Rewards on this purchase.
    </p>
    <a
      href="https://www.lifestylerewards.co.za/join"
      target="_blank"
      rel="noopener noreferrer"
      class="text-sm underline hover:opacity-80"
      [ngStyle]="{ color: getColorScheme() }"
    >
      Not a member? Register for Lifestyle Rewards
    </a>
  </div>
  <div
    class="grid grid-cols-1 gap-4 items-center justify-items-center md:justify-items-start mt-4 mb-6"
    [ngClass]="{
      'md:grid-cols-2': !activeCard && tokenization && !forceTokenization
    }"
  >
    <mat-slide-toggle
      class="align-middle inline-flex text-lg"
      color="primary"
      *ngIf="!activeCard && tokenization && !forceTokenization"
      formControlName="saveCard"
      [disabled]="loading"
      >Save card</mat-slide-toggle
    >
    <button
      mat-raised-button
      class="pay py-3 text-lg font-semibold tracking-widest min-w-max min-h-max w-full justify-self-center md:justify-self-end"
      [ngStyle]="
        !isPayButtonDisabled()
          ? {
              'background-color': getColorScheme(),
              color: getTextColor()
            }
          : {}
      "
      (click)="formValidation()"
      [disabled]="isPayButtonDisabled()"
    >
      Pay Now
    </button>
  </div>
  <p class="text-center md:text-left">
    <mat-icon class="align-top">info_outline</mat-icon> You may be redirected to
    your bank's secure site to authenticate yourself before making the payment.
  </p>
</form>
<div
  class="w-full h-full inline-block align-middle"
  *ngIf="!iframeLoaded && iframePostback"
>
  <div class="flex justify-center pt-4 pb-6">
    <h3 class="text-center"><b>Confirming Transaction Status</b></h3>
  </div>
  <div class="flex justify-center pt-4 pb-8">
    <mat-spinner></mat-spinner>
  </div>
</div>
<iframe
  name="output_frame"
  class="external-iframe"
  [attr.data-loaded]="iframeLoaded"
  src=""
  *ngIf="formSubmitted"
  #output_frame
  (load)="iframeOnLoad($event)"
></iframe>
